// Module
var code = "<template> <require from=\"app/core/components/assessments/assessment-attachments\"></require> <assessment-attachments target-id.bind=\"authId\" config.bind=\"config\" readonly.bind=\"readonly\" view-model.ref=\"$attachments\"> </assessment-attachments> </template> ";
// Exports
module.exports = code;